import { EnvironmentVariable, getEnvValue } from '../env';
import { ConsumerType } from '../types/consumer-type';

/**
 * Builds the authorization headers for API requests.
 *
 * When the consumer type is Cvent and a Cvent environment is configured, returns
 * Cvent-specific headers (`X-Cvent-Authorization` and `X-Cvent-Environment`);
 * otherwise falls back to a standard `Authorization` bearer header.
 *
 * @param token - Optional access token. Defaults to `window.accessToken` when omitted.
 * @returns A headers object suitable for spreading into a request's headers.
 */
export const buildAuthRequestHeaders = (AuthHeader?: string): Record<string, string> => {
  const useCventAuth = getEnvValue(EnvironmentVariable.CONSUMER_TYPE) === ConsumerType.Cvent;
  if (useCventAuth) {
    const cventEnvironment = getEnvValue(EnvironmentVariable.CVENT_ENVIRONMENT);
    if (AuthHeader && cventEnvironment) {
      return {
        'X-Cvent-Authorization': AuthHeader,
        'X-Cvent-Environment': cventEnvironment
      };
    }
  }

  return AuthHeader ? { Authorization: AuthHeader } : {};
};
